import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Patients
export const getPatients = () => apiClient.get('/patients');
export const getPatient = (id) => apiClient.get(`/patients/${id}`);
export const createPatient = (data) => apiClient.post('/patients', data);

// Medications
export const getMedications = (patientId) => apiClient.get(`/medications/${patientId}`);
export const createMedication = (data) => apiClient.post('/medications', data);
export const toggleMedication = (medId) => apiClient.put(`/medications/${medId}/toggle`);

// Motor Tests
export const getMotorTests = (patientId, tipo = null) => {
  const params = tipo ? `?tipo=${tipo}` : '';
  return apiClient.get(`/motor-tests/${patientId}${params}`);
};
export const createMotorTest = (data) => apiClient.post('/motor-tests', data);

// Daily Reports
export const getDailyReports = (patientId) => apiClient.get(`/daily-reports/${patientId}`);
export const createDailyReport = (data) => apiClient.post('/daily-reports', data);

// Emergency Contacts
export const getEmergencyContacts = (patientId) => apiClient.get(`/emergency-contacts/${patientId}`);
export const createEmergencyContact = (data) => apiClient.post('/emergency-contacts', data);
export const deleteEmergencyContact = (id) => apiClient.delete(`/emergency-contacts/${id}`);

// AI Insights
export const getAIInsights = (patientId) => apiClient.get(`/ai-insights/${patientId}`);
export const analyzePatientData = (patientId) => apiClient.post('/ai/analyze', { patient_id: patientId });
